
// photoswipe alex 210526 
import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe-lightbox.esm.min.js';

function initPhotoSwipe() {

  const galleryElement = document.querySelector('.product__media-list');

  if (!galleryElement) {
    console.log('NO GALLERY FOUND');
    return;
  }

  // Evitar doble init
  if (galleryElement.dataset.pswpInitialized) {
    return;
  }

  galleryElement.dataset.pswpInitialized = 'true';

  console.log('Initializing PhotoSwipe');

  const lightbox = new PhotoSwipeLightbox({
    gallery: galleryElement,

    children: '.pswp-gallery-item',

    pswpModule: () => import('https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js'),

    bgOpacity: 0.85,

    showHideAnimationType: 'zoom',

    preload: [3, 3],

    preloadFirstSlide: false,

    spacing: 0.08,

    loop: true,

    pinchToClose: true,

    closeOnVerticalDrag: true,

    secondaryZoomLevel: 2.5,

    maxZoomLevel: 4
  });

  lightbox.init();

  console.log('PhotoSwipe initialized');
}

// Primera carga
window.addEventListener('load', () => {
  setTimeout(initPhotoSwipe, 300);
});

// Dawn/Safari re-render raro
document.addEventListener('shopify:section:load', () => {
  setTimeout(initPhotoSwipe, 300);
});

// Backup extra por si Safari hace snapshot raro
setTimeout(initPhotoSwipe, 1200);
// photoswipe alex 210526